export enum QueryFetchingStatus {
  Error = "error",
  Pending = "pending",
  Success = "success",
}

export enum QueryMutationStatus {
  Idle = "idle",
  Error = "error",
  Loading = "loading",
  Success = "success",
}

export enum QueryAPIKey {
  //tenant
  GetTenantSpecificVariables = "getTenantSpecificVariables",

  // assets
  GetAssets = "getAssets",
  GetAssetsWithContent = "getAssetsWithContent",
  GetAsset = "getAsset",
  GetAssetRelationships = "getAssetRelationships",
  GetBulkAssetRelationships = "getBulkAssetRelationships",
  GetAllAssetVersions = "getAllAssetVersions",
  GetAssetContent = "getAssetContent",
  GetAssetsContent = "getAssetsContent",
  GetAssetShareHistory = "getAssetShareHistory",
  GetAssetBulkShareHistory = "getAssetBulkShareHistory",
  GetDataDictionary = "getDataDictionary",
  GetCommentThreads = "getCommentThreads",
  GetProjectTypeDefinitions = "getProjectTypeDefinitions",
  GetSubmitHistory = "getSubmitHistory",
  GetAssetsByRelationships = "getAssetsByRelationships",
  GetStructuredDocument = "getStructuredDocument",
  GetInvitation = "getInvitation",

  // Inline commenting for PDFViewer
  GetInlineCommentThreads = "getInlineCommentThreads",
  GetInlineHAQs = "getInlineHAQs",

  // documents
  GetDocument = "getDocument",
  GetDocuments = "getDocuments",
  GetDocumentTypes = "getDocumentTypes",
  GetDomains = "getDomains",
  GetCommentThread = "getCommentThread",

  // feature flags
  GetFeatureFlags = "getFeatureFlags",

  // projects
  GetProjectTypes = "getProjectTypes",
  GetProjectData = "GetProjectData",
  GetProjects = "getProjects",
  GetProjectsCountsByStatus = "getProjectsCountsByStatus",
  GetProjectTypeMetadata = "getProjectTypeMetadata",
  GetQuestions = "getQuestions",
  GetLanguages = "getLanguages",
  GetRecentProjects = "getRecentProjects",
  GetUserProjects = "getUserProjects",
  GetProjectPermissions = "getProjectPermissions",
  GetProjectInvitations = "getProjectInvitations",
  GetProjectCounts = "getProjectCounts",
  GetProjectParticipants = "getProjectParticipants",

  // users
  GetCurrentUser = "getCurrentUser",
  GetUserProjectRoles = "getUserProjectRoles",
  GetCurrentUserRoles = "getCurrentUserRoles",
  GetProjectMembers = "getProjectMembers",
  GetUsersLastSyncTimestamp = "getUsersLastSyncTimestamp",
  GetUsersList = "getUsersList",
  GetUserGroups = "getUserGroups",
  GetTimeZones = "getTimeZones",
  GetUser = "getUser",
  GetLegalAcknowledgements = "getLegalAcknowledgements",

  // tasks
  GetTasks = "getTasks",
  GetTask = "getTask",
  GetGroupedTask = "getGroupedTask",
  GetTasksPaginated = "getTasksPaginated",
  GetTaskParticipants = "getTaskParticipants",

  // milestones
  GetMilestones = "getMilestones",
  GetAvailableMilestonePresetTypes = "getAvailableMilestonePresetTypes",

  // organizations
  GetOrganizations = "getOrganizations",

  // notifications
  GetNotificationsForUser = "getNotificationsForUser",
  GetUnreadNotificationCount = "getUnreadNotificationCount",

  // workflows
  GetWorkflow = "getWorkflow",

  // activity
  GetRecentActivity = "getRecentActivity",

  // entities
  GetEntities = "getEntities",
  GetAssignedEntities = "getAssignedEntities",
  GetAssignedHAOrganizations = "getAssignedHAOrganizations",

  // eCTD
  GetECTDSubmitHistoryRows = "getECTDSubmitHistoryRows",

  // session
  GetUserSession = "getUserSession",

  // global banner
  GetGlobalBannerConfig = "getGlobalBannerConfig",

  // user registration
  GetRegistration = "getRegistration",

  // configurations
  GetConfigurations = "getConfigurations",
  GetTenants = "getTenants",
}

export enum QueryMutationKey {
  // comments
  AddComment = "addComment",
  RemoveComment = "removeComment",
  UpdateComment = "updateComment",
}

export const DEFAULT_POLLING_INTERVAL = 1000;
// used for things that could take several minutes and don't need an immediate update
export const EXTENDED_POLLING_INTERVAL = 10000;
export const DEFAULT_NOTIFICATIONS_POLLING_INTERVAL = 5000;

export const DEFAULT_ASSET_STATUS_UPDATE_INTERVAL = 300000; // 5 minutes

export const MAX_API_RESULT_SIZE = 2000;

// BE can extract current user from headers
// FE can pass string 'self'
export const NOTIFICATIONS_CURRENT_USER_ID = "self";

export const QUERY_RETRY_COUNT = 3;
